var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["reviews", { "no-reviews": !_vm.REVIEWS.length }] },
    [
      _c(
        "div",
        { staticClass: "reviews__inner" },
        [
          _c("h2", { staticClass: "reviews__title" }, [
            _vm._v("\n      Отзывы\n    ")
          ]),
          _vm.reviewsInitialLoadingDone
            ? [
                _c(
                  "div",
                  { staticClass: "reviews__stats" },
                  [
                    _c("review-stats", {
                      on: { "show-form": _vm.showReviewForm }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "reviews__all-reviews" },
                  [
                    _c("product-reviews", {
                      attrs: { "product-code": _vm.PRODUCT.code }
                    })
                  ],
                  1
                )
              ]
            : [
                _c(
                  "div",
                  { staticClass: "reviews__loader" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      [_c("ui-loader", { attrs: { size: "60" } })],
                      1
                    )
                  ],
                  1
                )
              ],
          _c("review-modal", {
            attrs: { shown: _vm.isFormShown, "product-code": _vm.PRODUCT.code },
            on: { close: _vm.hideReviewForm }
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }